import Vue from "vue";
import VueApollo from "vue-apollo";
import {ApolloClient} from 'apollo-client'
import { split } from 'apollo-link'
import {createHttpLink} from 'apollo-link-http'
import {WebSocketLink, WebSocketParams} from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import {InMemoryCache} from 'apollo-cache-inmemory'
import authHeader from "@/services/auth-header";

Vue.use(VueApollo);

class Apollo {
    private cache = new InMemoryCache({
        addTypename: false
    });
    private client?: ApolloClient<any>;

    constructor() {
        const u: any = JSON.parse(<string>localStorage.getItem('user'));
        if(u) {
            this.initClient(u.token, u.office);
        }
    }
    private getClient() {
        if(this.client) {
            return this.client;
        }
        throw new Error('ApolloClient not initialized');
    }


    public removeClient() {
        this.client = undefined;
    }
    public initClient(token: string, office: string) {
        const httpLink = createHttpLink({
            // You should use an absolute URL here
            uri: `${window.location.protocol}//${window.location.host}/graphql`,
            // uri: `http://${window.location.host}/graphql`,
            headers: authHeader(token, office),
        });
        // const wsLink = new WebSocketLink({
        //     uri: `ws://${window.location.host}/subscriptions`,
        //     options: {
        //         reconnect: true,
        //     },
        // });
        const link = split(
            // split based on operation type
            ({ query }) => {
                const definition = getMainDefinition(query)
                return (
                    definition.kind === 'OperationDefinition'
                )
            },
            // wsLink,
            httpLink,
        );
        this.client = new ApolloClient({
            link: link,
            cache: this.cache,
            defaultOptions: {
                mutate: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
                watchQuery: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'ignore',
                },
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
            }
        });
    }

    async query(param: { variables?: any; query: any }) {
        return this.getClient().query(param);
    }

    subscribe(param: { variables?: any; query: any }) {
        return this.getClient().subscribe({variables: param.variables, query: param.query, fetchPolicy: 'no-cache'});
    }

    async mutate(param: { mutation: any; variables?: any }) {
        return this.getClient().mutate(param);
    }
}

// HTTP connection to the API

// Cache implementation

// Create the apollo client
export const apollo = new Apollo();


